import { render, staticRenderFns } from "./OverviewInbox.vue?vue&type=template&id=78eeadcd&scoped=true&"
import script from "./OverviewInbox.vue?vue&type=script&lang=js&"
export * from "./OverviewInbox.vue?vue&type=script&lang=js&"
import style0 from "./OverviewInbox.vue?vue&type=style&index=0&id=78eeadcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eeadcd",
  null
  
)

export default component.exports